import type { TFunction } from 'i18next';
import { unitLabel, type IStockPrefill } from '@d-orca/shared/client/logistics';

/**
 * A stored unit as the stock form shows it. A record holds the unit's KEY
 * (or a legacy label in either language); the form's unit field is a typed
 * combo over the viewer's labels, so a stored unit is translated on its way
 * in, and the save stores the key again (`unitToStore` in buildSnapshotBody).
 * Blank stays absent.
 */
export function shownUnit(t: TFunction, unit: string | null | undefined): string | undefined {
  return unit ? unitLabel(t, unit) : undefined;
}

/** The prefill with both of its units — the one it opens on and the one the
 *  material already held — in the viewer's labels, so the seeded amber and the
 *  "unit unchanged" comparison read the same text the field shows. */
export function withUnitLabels(prefill: IStockPrefill | null, t: TFunction): IStockPrefill | null {
  if (!prefill) return null;
  const { previous } = prefill;
  return {
    ...prefill,
    unit: shownUnit(t, prefill.unit),
    ...(previous ? { previous: { ...previous, unit: shownUnit(t, previous.unit) } } : {}),
  };
}
